import { Ref } from '@wix/materializer'
import { GhostPropertiesItem } from '@wix/thunderbolt-becky-root'
import { Component } from '@wix/thunderbolt-becky-types'
import { getDataItemRefsWithOverrides } from './dataConsumption'
import { ScopedCreateRef } from '../compNodeUtils'
import { GetOverrideDataRefs } from './types'

export const consumePropertyItem = ({
	templateComponent,
	isMobileView,
	getOverrideDataRefs,
	createRefInTemplateNamespace,
}: {
	templateComponent: Component
	isMobileView: boolean
	getOverrideDataRefs: GetOverrideDataRefs
	createRefInTemplateNamespace: ScopedCreateRef
}) => ({
	desktopItemWithOverrides: getDataItemRefsWithOverrides({
		templateComponent,
		queryName: 'propertyQuery',
		getOverrideDataRefs,
		createRefInTemplateNamespace,
	}).dataItemWithOverrides as Array<Ref<GhostPropertiesItem>>,
	mobileItemWithOverrides:
		isMobileView &&
		(getDataItemRefsWithOverrides({
			templateComponent,
			queryName: 'propertyQuery',
			itemSuffix: '-mobile',
			getOverrideDataRefs,
			createRefInTemplateNamespace,
		}).dataItemWithOverrides as Array<Ref<GhostPropertiesItem>>),
})
